<template>
    <svg :class="[width, height]" viewBox="0 0 14 14">
        <g id="return" transform="translate(-702 -560)">
            <path id="Path_1274" data-name="Path 1274" d="M18.25,15H5.75a.75.75,0,0,1,0-1.5H17.5V5.75a.75.75,0,0,1,1.5,0v8.5A.75.75,0,0,1,18.25,15Z" transform="translate(697 555)" fill="#f9d493"/>
            <path id="Path_1275" data-name="Path 1275" d="M9.75,19a.744.744,0,0,1-.53-.22l-4-4a.75.75,0,0,1,0-1.061l4-4a.75.75,0,1,1,1.061,1.061l-3.47,3.47,3.47,3.47A.75.75,0,0,1,9.75,19Z" transform="translate(697 555)"
                  fill="#f9d493"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "ReturnIcon",
    props: {
        width: {
            type: String,
            default: "w-[14px]"
        },
        height: {
            type: String,
            default: "h-[14px]"
        },
    }
}
</script>
